export default __webpack_public_path__ + "static/media/FSKoopman-Bold.9730b06e.woff";